import { render, staticRenderFns } from "./ThousandNumberInput.vue?vue&type=template&id=38ebf4fd&"
import script from "./ThousandNumberInput.vue?vue&type=script&lang=ts&"
export * from "./ThousandNumberInput.vue?vue&type=script&lang=ts&"
import style0 from "@/assets/css/components/forms/inputs/thousand-number-input.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports